import { Component, Input, OnInit } from "@angular/core";
import { SubscribingComponent } from "../../common";
import { TaxCardSingleRow } from "../tax-card-single-row";
import { Employer } from "app/statements/employer";
import { LohnsteuerValidator } from "app/statements/lohnsteuerValidator";
import { ErrorMessage } from "app/core/form-validator/validatorInterface";

export enum SingleRowCollapseType {
  useAdditionalCartFrom29To32 = "useAdditionalCartFrom29To32",
  useAdditionalCartFrom8To14 = "useAdditionalCartFrom8To14"
}

export enum SingleRowInputTypes {
  DATE = "date",
  PRICE = "price",
  YEAR = "year",
  NO_INPUT = "no_input"
}

@Component({
    selector: "app-tax-card-single-row",
    templateUrl: "./tax-card-single-row.component.html",
    styleUrls: ["./tax-card-single-row.component.scss"],
    standalone: false
})
export class TaxCardSingleRowComponent extends SubscribingComponent implements OnInit {
  @Input() row: TaxCardSingleRow = new TaxCardSingleRow();
  @Input() employer: Employer;
  @Input() employers: Employer[];
  @Input() currentIndex: number;
  @Input() spouseId: number;
  @Input() epValidator: ErrorMessage[] = [];
  @Input() empWarningList: LohnsteuerValidator[] = [];
  @Input() unlocked = "";
  @Input() codes: Record<string, unknown>;
  @Input() isBusiness: boolean;
  @Input() isVerification: boolean;
  @Input() isSummary: boolean;
  @Input() isEditableSummaryEmployer: boolean;
  @Input() employerFieldEdit: boolean;
  @Input() toggleField: Function;
  @Input() collapseType: SingleRowCollapseType;
  public showCollapse = false;
  public singleRowInputTypes = SingleRowInputTypes;

  constructor() {
    super();
  }

  ngOnInit(): void {
    const collapseType = this.row.collapseType;

    this.showCollapse = this.employer[collapseType];
  }

  public findValidationByFieldName(validationFieldNames: string[]): boolean {
    return !!this.epValidator.find((x) => validationFieldNames?.indexOf(x.fieldName) !== -1);
  }

  public handleShowCollapse(): void {
    const collapseType = this.row.collapseType;
    this.showCollapse = !this.showCollapse;
    if (collapseType) this.employer[collapseType] = !this.employer[collapseType];
  }

  public onBlurMonth(event: FocusEvent, field: string): void {
    const input = event.target as HTMLInputElement;
    if (!input) {
      return;
    }

    let val = input.value.trim();

    if (/^\d{1}$/.test(val)) {
      val = "0" + val;
    }

    if (field === "pensionBenefitsPaymentsEnd") {
      this.employer.pensionBenefitsPaymentsEnd = val;
    } else {
      this.employer.pensionBenefitsPaymentsStart = val;
    }
  }
}
